import React from 'react';
export const ThankYouIcon = () => {
  return /*#__PURE__*/React.createElement("svg", {
    width: "195",
    height: "180",
    viewBox: "0 0 195 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.16 101.977L168.66 99.633C170.734 89.9283 164.405 81.8484 151.973 78.3267V78.3267",
    stroke: "#D4D4E0",
    strokeWidth: "1.5",
    strokeLinejoin: "round",
    strokeDasharray: "2 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 74.5V74.5C70.1964 77.6929 57.9517 86.542 55.8092 95.5958L54.1753 102.5",
    stroke: "#D4D4E0",
    strokeWidth: "1.5",
    strokeLinejoin: "round",
    strokeDasharray: "2 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2829 143.601L81.6576 146.988C91.291 149.427 104.274 147.488 114.783 142.039V142.039",
    stroke: "#D4D4E0",
    strokeWidth: "1.5",
    strokeLinejoin: "round",
    strokeDasharray: "2 4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_19246_7037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.836 81.4688C135.19 91.115 116.617 96.3531 103.352 93.1685C98.7367 92.0604 93.828 88.6007 91.8088 86.0809C86.8688 78.6707 90.5104 76.226 96.8001 69.9363C106.446 60.2901 125.019 55.0519 138.284 58.2365C140.684 58.8127 142.28 58.7434 143.925 59.6213C144.182 59.7584 144.389 59.927 144.567 60.109C150.533 66.237 152.492 73.8131 144.836 81.4688Z",
    fill: "url(#paint0_linear_19246_7037)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_19246_7037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.379 130.678C159.733 140.324 141.16 145.563 127.895 142.378C123.28 141.27 118.371 137.81 116.352 135.29C111.412 127.88 115.053 125.435 121.343 119.146C130.989 109.5 149.562 104.261 162.827 107.446C165.227 108.022 166.823 107.953 168.468 108.831C168.725 108.968 168.932 109.136 169.11 109.318C175.076 115.447 177.035 123.023 169.379 130.678Z",
    fill: "url(#paint1_linear_19246_7037)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_19246_7037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5171 133.766C65.8709 143.412 47.2978 148.65 34.033 145.465C29.4174 144.357 24.5086 140.898 22.4895 138.378C17.5494 130.968 21.1911 128.523 27.4808 122.233C37.127 112.587 55.7001 107.349 68.965 110.533C71.3648 111.11 72.9606 111.04 74.6056 111.918C74.8623 112.055 75.0701 112.224 75.2473 112.406C81.2139 118.534 83.1728 126.11 75.5171 133.766Z",
    fill: "url(#paint2_linear_19246_7037)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "24.7006",
    cy: "24.7006",
    r: "24.7006",
    transform: "matrix(0.97237 0.233445 -0.707107 0.707107 136.311 99.2036)",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.326 123.152C142.25 123.123 142.142 123.097 142.037 123.082C139.976 122.523 139.552 120.861 141.098 119.316C142.679 117.735 145.716 116.872 147.902 117.397C150.075 117.919 150.557 119.626 148.976 121.207C147.418 122.75 144.492 123.607 142.326 123.152Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.512 130.824C140.951 131.735 137.252 131.919 134.13 131.169C131.007 130.42 129.038 128.875 128.324 126.938C129.265 126.146 130.789 125.515 132.702 125.195C137.582 124.396 142.962 125.687 144.639 128.061C145.296 128.998 145.213 129.975 144.512 130.824Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.13 131.169C140.762 132.761 150.049 130.142 154.872 125.319C159.695 120.496 158.228 115.295 151.596 113.703C144.963 112.111 135.677 114.73 130.854 119.553C126.031 124.376 127.497 129.577 134.13 131.169Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "24.7006",
    cy: "24.7006",
    r: "24.7006",
    transform: "matrix(0.97237 0.233445 -0.707107 0.707107 41.9319 101.995)",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9467 125.943C47.8714 125.914 47.7633 125.888 47.6585 125.874C45.5973 125.314 45.1736 123.653 46.7193 122.107C48.3 120.526 51.3371 119.664 53.5227 120.188C55.6964 120.71 56.1779 122.418 54.5973 123.998C53.0395 125.541 50.1127 126.398 47.9467 125.943Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.133 133.616C46.5719 134.526 42.8732 134.71 39.7508 133.961C36.6284 133.211 34.6589 131.666 33.9447 129.729C34.8857 128.937 36.4097 128.307 38.3234 127.987C43.2033 127.187 48.5834 128.479 50.2605 130.852C50.9167 131.79 50.8338 132.766 50.133 133.616Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7509 133.96C46.3833 135.553 55.6698 132.934 60.4929 128.111C65.316 123.287 63.8493 118.087 57.2168 116.494C50.5844 114.902 41.2979 117.521 36.4748 122.344C31.6517 127.167 33.1184 132.368 39.7509 133.96Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "24.7006",
    cy: "24.7006",
    r: "24.7006",
    transform: "matrix(0.97237 0.233445 -0.707107 0.707107 111.796 50)",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.811 73.9479C117.736 73.919 117.628 73.8931 117.523 73.8787C115.462 73.3189 115.038 71.6577 116.584 70.112C118.164 68.5313 121.201 67.6685 123.387 68.1932C125.561 68.7151 126.042 70.4226 124.462 72.0033C122.904 73.5462 119.977 74.403 117.811 73.9479Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.997 81.6207C116.436 82.531 112.737 82.7151 109.615 81.9655C106.493 81.2159 104.523 79.6709 103.809 77.7342C104.75 76.9422 106.274 76.3117 108.188 75.9914C113.068 75.192 118.448 76.4836 120.125 78.8573C120.781 79.7945 120.698 80.7709 119.997 81.6207Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.615 81.9653C116.248 83.5576 125.534 80.9386 130.357 76.1155C135.18 71.2924 133.714 66.0916 127.081 64.4993C120.449 62.907 111.162 65.5261 106.339 70.3492C101.516 75.1723 102.983 80.373 109.615 81.9653Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_19246_7037",
    x: "69.5078",
    y: "27.3042",
    width: "100.336",
    height: "94.7964",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "-10"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19246_7037"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "8"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_19246_7037",
    result: "effect2_dropShadow_19246_7037"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_19246_7037",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_19246_7037",
    x: "94.0508",
    y: "76.5137",
    width: "100.336",
    height: "94.7964",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "-10"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19246_7037"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "8"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_19246_7037",
    result: "effect2_dropShadow_19246_7037"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_19246_7037",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_19246_7037",
    x: "0.188477",
    y: "79.6011",
    width: "100.336",
    height: "94.7964",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "-10"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19246_7037"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "8"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_19246_7037",
    result: "effect2_dropShadow_19246_7037"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_19246_7037",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19246_7037",
    x1: "163.589",
    y1: "63.0935",
    x2: "137.246",
    y2: "30.5416",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B98DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.427083",
    stopColor: "#E9ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.770833",
    stopColor: "#CED6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.857402",
    stopColor: "#94A0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9999",
    stopColor: "#C1CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DAE0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19246_7037",
    x1: "188.132",
    y1: "112.303",
    x2: "161.789",
    y2: "79.7511",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B98DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.427083",
    stopColor: "#E9ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.770833",
    stopColor: "#CED6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.857402",
    stopColor: "#94A0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9999",
    stopColor: "#C1CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DAE0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19246_7037",
    x1: "94.2694",
    y1: "115.39",
    x2: "67.9264",
    y2: "82.8385",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B98DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.427083",
    stopColor: "#E9ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.770833",
    stopColor: "#CED6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.857402",
    stopColor: "#94A0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9999",
    stopColor: "#C1CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DAE0FF"
  }))));
};